<template>
  <div>
    <v-card-text class="pt-0">
      <template v-if="!t">
        <v-row dense>
          <v-btn
            color="primary"
            class="mt-4"
            text
            @click="addTest('', undefined)"
          >
            <v-icon left>add</v-icon> {{ $t("tests.testEdit.addTest") }}
          </v-btn>
        </v-row>
      </template>
      <v-form ref="testForm">
        <template v-if="t && t.questions && t.questions.length">
          <v-row dense>
            <v-combobox
              class="pb-4 red-background-error-text"
              v-model="t.name"
              :items="tests"
              label="Testi nimi"
              item-text="name"
              @change="testSelected"
              return-object
              :rules="[rules.required(t.name, 0), rules.atleastOneQuestion]"
              hide-details="auto"
            />
          </v-row>
          <v-row>
            <v-tabs fixed-tabs v-model="tab" class="pb-4">
              <template v-for="(locale, i) in locales">
                <v-tab
                  :key="i"
                  @click="changeCurrentLocale(locale.value)"
                  :tab="locale.value"
                  >{{ locale.text }}

                  <v-btn
                    v-if="!testLocales.includes(locale.value)"
                    class="ml-3"
                    icon
                    @click.stop="addLocale(locale.value, i)"
                  >
                    <v-icon> add</v-icon>
                  </v-btn>

                  <v-btn
                    v-else
                    class="ml-3"
                    icon
                    :disabled="testLocales.length == 1"
                    @click.stop="deleteLocale(locale.value, i)"
                  >
                    <v-icon> delete_forever </v-icon>
                  </v-btn>
                </v-tab>
              </template>
            </v-tabs>
          </v-row>
          <v-tabs-items v-model="tab" touchless>
            <template v-for="(l, localeIndex) in locales">
              <v-tab-item eager :key="localeIndex">
                <template
                  v-for="(q, i) in t.questions.filter(
                    (q) => q.language == l.value
                  )"
                >
                  <v-row dense :key="`question-${l}-${i}`" align="center">
                    <v-textarea
                      rows="1"
                      :rules="[
                        rules.required(q.question, localeIndex),
                        rules.atleastTwoAnswers(q, localeIndex),
                        rules.atleastOneWronAndOneCorrectAnswer(q, localeIndex),
                        rules.maxLength(q.question, localeIndex),
                      ]"
                      hide-details="auto"
                      v-model="q.question"
                      auto-grow
                      :label="`${$t('tests.testEdit.question')}  ${i + 1}`"
                      class="red-background-error-text"
                    />
                    <v-btn
                      :disabled="t.questions.length < 2"
                      icon
                      small
                      @click="deleteQuestion(q)"
                    >
                      <v-icon>delete_forever</v-icon>
                    </v-btn>
                  </v-row>
                  <v-row dense align="center" class="mt-4">
                    <v-btn
                      v-if="!q.file"
                      text
                      color="primary"
                      small
                      @click="selectImage(q)"
                    >
                      <v-icon left>mdi-plus</v-icon>
                      {{ $t("tests.testEdit.addImage") }}
                    </v-btn>
                    <div v-if="q.file">
                      <a
                        :href="q.file.url"
                        target="_blank"
                        style="display: inline-block; margin-top: 10px"
                      >
                        <v-icon class="ml-1 mr-2" color="primary"
                          >mdi-paperclip</v-icon
                        >
                        {{ q.file.name }}
                      </a>
                    </div>
                    <v-spacer />
                    <v-btn
                      v-if="q.file"
                      text
                      icon
                      small
                      @click="deleteImage(q)"
                    >
                      <v-icon>delete_forever</v-icon>
                    </v-btn>

                    <input
                      type="file"
                      ref="imageInput"
                      style="display: none"
                      accept=".jpg,.jpeg,.png,.gif,.bmp"
                      @change="attachLocalFile"
                    />
                  </v-row>

                  <template v-for="(a, j) in q.answers">
                    <v-row
                      dense
                      :key="`answer-${l.value}-${i}-${j}`"
                      align="center"
                    >
                      <v-btn
                        class="mt-4"
                        icon
                        :color="a.isCorrect ? 'success' : 'error'"
                        @click="setIsCorrect(q.answers, a)"
                      >
                        <v-icon>{{ a.isCorrect ? "check" : "close" }}</v-icon>
                      </v-btn>
                      <v-textarea
                        rows="1"
                        auto-grow
                        :rules="[
                          rules.required(a.answer, localeIndex),
                          rules.maxLength(a.answer, localeIndex),
                        ]"
                        hide-details="auto"
                        v-model="a.answer"
                        class="red-background-error-text"
                      />
                      <v-btn
                        class="mt-4"
                        :disabled="q.answers.length <= 2"
                        icon
                        small
                        @click="deleteAnswer(q, j)"
                      >
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                    </v-row>
                  </template>
                  <v-row :key="`btn-${l.value}-${i}`" dense class="mb-4 mt-1">
                    <v-btn class="mt-3" icon @click="addAnswer(q)">
                      <v-icon>add </v-icon>
                    </v-btn>
                    <v-text-field
                      :placeholder="$t('tests.testEdit.addAnswer')"
                      @click="addAnswer(q)"
                      readonly
                    />
                    <div style="padding-left: 14px; padding-right: 14px" />
                  </v-row>
                </template>
                <v-row dense class="my-4">
                  <v-btn
                    color="primary"
                    small
                    text
                    @click="addQuestion(l.value)"
                    ><v-icon left>add</v-icon
                    >{{ $t("tests.testEdit.addQuestion") }}</v-btn
                  >
                  <div style="padding-left: 14px; padding-right: 14px" />
                </v-row>
              </v-tab-item>
            </template>
          </v-tabs-items>
        </template>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="grey darken-1" text @click="close">
        {{ $t("dialog.cancel") }}
      </v-btn>
      <v-btn color="primary" text @click="save">
        {{ $t("tests.testEdit.save") }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import UpdateTestQuery from "@/graphql/UpdateTest.gql";
import TestsQuery from "@/graphql/queries/instruction/test/Tests.gql";
import UploadQuestionImageQuery from "@/graphql/mutation/instruction/test/UploadQuestionImage.gql";

export default {
  props: ["test", "locales"],
  data() {
    return {
      rules: {
        required: (value, localeIndex) => {
          const isValid = !!value.length;

          if (!isValid) {
            this.appendNotValidTabs(localeIndex);
          }
          return isValid || this.$i18n.t("validation.required");
        },
        maxLength: (value, localeIndex) => {
          const isValid = value.length <= 300;

          if (!isValid) {
            this.appendNotValidTabs(localeIndex);
          }
          return isValid || this.$i18n.t("validation.length", { n: 300 });
        },

        atleastOneQuestion: () =>
          (this.t && !!this.t.questions.length) ||
          this.$i18n.t("validation.atleastOneQuestion"),

        atleastTwoAnswers: (question, localeIndex) => {
          const isValid = question.answers.length >= 2;

          if (!isValid) {
            this.appendNotValidTabs(localeIndex);
          }
          return isValid || this.$i18n.t("validation.atleastTwoAnswers");
        },

        atleastOneWronAndOneCorrectAnswer: (question, localeIndex) => {
          let correct = 0,
            wrong = 0;
          question.answers.forEach((a) => {
            a.isCorrect ? correct++ : wrong++;
          });
          const isValid = !!correct && !!wrong;

          if (!isValid) {
            this.appendNotValidTabs(localeIndex);
          }
          return (
            isValid || this.$i18n.t("validation.atleastOneCorrectAndOneWrong")
          );
        },
      },
      tab: null,
      notValidTabs: [],
      t: null,
      selectedQuestionIndex: null,
      fileIdsToDelete: [],
    };
  },
  mounted() {
    if (!this.test.questions.length) {
      this.addTest(this.test.name);
      return;
    }
    this.t = this.test;
  },
  computed: {
    testLocales() {
      return (
        (this.test &&
          this.test.questions.length &&
          this.test.questions
            .map((q) => q.language)
            .filter((v, i, a) => a.indexOf(v) === i)) || [this.locales[0].value]
      );
    },
    currentLocale: {
      get() {
        return (
          (this.test &&
            this.test.questions[0] &&
            this.test.questions[0].hasOwnProperty("language") &&
            this.test.questions[0].language) ||
          this.locales[0].value
        );
      },
      set(newVal) {
        return newVal;
      },
    },
  },
  methods: {
    haveLocale(locale) {
      return this.testLocales.includes(locale);
    },
    appendNotValidTabs(localeIndex) {
      !this.notValidTabs.includes(localeIndex) &&
        this.notValidTabs.push(localeIndex);
    },

    changeCurrentLocale(locale) {
      this.currentLocale = locale;
    },

    changeLocale(locale, tab) {
      this.changeCurrentLocale(locale);
      this.tab = tab;
    },

    deleteLocale(locale, tab) {
      this.testLocales.splice(this.testLocales.indexOf(locale), 1);
      this.t.questions.forEach((q) => {
        if (q.language == locale) {
          this.deleteQuestion(q);
        }
      });
      this.changeLocale(locale, tab);
    },
    addLocale(locale, tab) {
      this.testLocales.push(locale);
      this.addQuestion(locale);
      this.changeLocale(locale, tab);
    },

    testSelected(sel) {
      if (typeof sel === "string") {
        sel = this.tests.find((_t) => _t.name === sel) || sel;
      }

      var existing = false;
      if (typeof sel === "object") {
        this.addTest(sel.name, sel.questions);
        existing = true;
      } else if (!existing) {
        this.t.name = sel;
      }
    },

    close() {
      this.$emit("done");
    },

    async save() {
      if (this.notValidTabs.length) {
        this.tab = this.notValidTabs[0];
        this.notValidTabs.splice(0, 1);
      }
      if (!this.$refs.testForm.validate()) {
        this.$store.commit("push_global_message", {
          color: "error",
          text: this.$i18n.t("error.saveFailed"),
        });
        return;
      }

      for (const q of this.t.questions) {
        if (q.file && q.file.isLocal) {
          const res = await this.$apollo.mutate({
            mutation: UploadQuestionImageQuery,
            variables: {
              file: q.file.file,
              testName: this.t.name,
            },
          });
          q.file = res.data.file;
        }
      }

      const questions = this.t.questions.map((q) => ({
        answers: q.answers.map((a) => ({
          answer: a.answer,
          id: a.id || null,
          isCorrect: a.isCorrect,
          questionId: a.questionId,
        })),
        id: q.id || null,
        language: q.language,
        question: q.question,
        fileId: q.file ? q.file.id : null,
        testId: q.testId,
      }));

      try {
        const resp = await this.$apollo.mutate({
          mutation: UpdateTestQuery,
          variables: {
            ti: {
              id: this.t.id,
              name: this.t.name,
              questions,
            },
            fileIdsToDelete: this.fileIdsToDelete,
          },
        });
        this.t = resp.data.test;
        this.$store.commit("push_global_message", {
          color: "success",
          text: this.$i18n.t("tests.testEdit.saved"),
        });
        this.$emit("test-saved", resp.data.test.id);
      } catch (err) {
        this.$store.commit("push_global_message", {
          color: "error",
          text: `${this.$i18n.t("tests.testEdit.saveFailed")}: ${err}`,
        });
      }
    },
    createNewAnswer(isCorrect, answer) {
      return {
        isCorrect: isCorrect,
        answer: answer || "",
        questionId: null,
      };
    },
    createNewQuestion(question, language, answers) {
      const newQuestion = {
        language: language || this.currentLocale,
        question: question || "",
        testId: null,
        file: null,
        answers: [],
      };

      answers && answers.length
        ? answers.forEach((a) => {
            newQuestion.answers.push(
              this.$set(
                {},
                "answer",
                this.createNewAnswer(a.isCorrect, a.answer)
              )
            );
          })
        : newQuestion.answers.push(
            this.$set({}, "answer", this.createNewAnswer(true)),
            this.$set({}, "answer", this.createNewAnswer(false))
          );
      return newQuestion;
    },
    addTest(name, questions) {
      if (questions && questions.length) {
        this.$set(this.t, "questions", []);

        questions.forEach((q) => {
          this.t.questions.push(
            this.createNewQuestion(q.question, q.language, q.file, q.answers)
          );
        });
      } else {
        let test = {};
        this.$set(test, "name", name || "");
        this.$set(test, "questions", [
          this.createNewQuestion(undefined, this.currentLocale, undefined),
        ]);
        this.t = test;
      }
    },
    addQuestion(language) {
      this.t.questions.push(
        this.createNewQuestion(undefined, language, undefined)
      );
    },
    addAnswer(question) {
      question.answers.push(
        this.$set({}, "answer", this.createNewAnswer(false))
      );
    },
    deleteAnswer(question, index) {
      if (question.answers.length <= 2) {
        return;
      }
      this.$delete(question.answers, index);
      this.setIsCorrect(question.answers, question.answers[0]);
    },
    deleteQuestion(q) {
      this.$delete(this.t.questions, this.t.questions.indexOf(q));
    },
    deleteImage(question) {
      if (!question.file) return;

      if (question.file.isLocal) {
        this.$set(question, "file", null);
        return;
      }

      this.fileIdsToDelete.push(question.file.id);
      this.$set(question, "file", null);
    },
    removeTest() {
      this.t.questions = { name: "", questions: [] };
    },
    setIsCorrect(answers, answer) {
      if (
        answers.length === 2 &&
        answers.reduce((correctCount, a) => correctCount + a.isCorrect, 0) == 1
      ) {
        answers.forEach((a) => {
          this.$set(a, "isCorrect", !a.isCorrect);
        });
        return;
      }

      let correctAnswerCount = 0;
      let notCorrectAnswerCount = 0;
      answers.forEach((a) => {
        a.isCorrect ? correctAnswerCount++ : notCorrectAnswerCount++;
      });

      if (answer.isCorrect && correctAnswerCount-- >= 2) {
        this.$set(answer, "isCorrect", false);
      } else if (!answer.isCorrect && notCorrectAnswerCount-- >= 2) {
        this.$set(answer, "isCorrect", true);
      }
    },
    selectImage(question) {
      this.selectedQuestionIndex = this.t.questions.indexOf(question);
      this.$refs.imageInput[0].click();
    },
    attachLocalFile(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (this.selectedQuestionIndex != null) {
        const question = this.t.questions[this.selectedQuestionIndex];
        question.file = {
          file,
          name: file.name,
          url: URL.createObjectURL(file),
          isLocal: true,
        };
      }

      event.target.value = "";
    },
  },
  apollo: {
    tests: {
      query: TestsQuery,
    },
  },
};
</script>

<style>
.theme--light.v-input input::placeholder {
  color: rgba(0, 0, 0, 0.54);
}
.red-background-error-text .v-messages__message {
  color: white !important;
  background-color: #ff5252 !important;
  padding: 5px 10px;
  border-radius: 5px;
  max-width: fit-content;
}
</style>
